export default function (imgContainer, fn) {

    let sources = [];
    let preloadElems = imgContainer[0].getElementsByTagName('img')
    let preloadElemsLength = preloadElems.length

    for (let i = 0; i < preloadElemsLength; i++) {
        sources.push(preloadElems[i].src)
    }

    let images = [];
    let loadedImages = 0;
    let numImages = sources.length;
    for (let i = 0; i < numImages; i++) {
        images[i] = new Image();
        images[i].onload = function () {
            if (++loadedImages >= numImages) {
                fn();
            }
        };
        images[i].src = sources[i]; //bind onload before setting src bug in some chrome versions
    }
}